const localConfig = {
	// Relative URLs so the app works on whatever host serves it
	// (dms.jakson-green.com, dms.energxiq.com, etc.) — nginx routes /api/ to the backend.
	GRAPHQL_URI: '/api/graphql/',
	REST_URI: '/api/',
	REDIRECT_URL: '/',
};

const productionConfig = {
	 GRAPHQL_URI: "https://13.50.27.85:8000/graphql/",
	 REST_URI: "https://13.50.27.85/",
     REDIRECT_URL: "https://13.50.27.85:3000/"
};;

// const productionConfig = {
// 	 GRAPHQL_URI: "https://apollo.com/graphql/",
// };;

const config = process.env.REACT_APP_BUILD_ENV === 'production' ? productionConfig : localConfig;

console.log(process.env.REACT_APP_BUILD_ENV, config, process.env.REACT_APP_BUILD_ENV === 'production');
export default {
	...config,
};
